'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:close');
}

var _invoke = require('../invoke');

/**
 * 关闭当前 webview
 *
 * 与 `hbnb.webivew.open` 配合使用
 *
 * TODO: ANDROID 旧版实现有问题
 *
 * 支持版本
 * + iHotel/?
 *
 * @memberof webview
 * @static
 * @name close
 * @return {Undefined}
 * @example
 *  hbnb.webview.close();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    _invoke('webview', 'close');
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/close.js
// module id = 659
// module chunks = 0